import { MutationTree } from 'vuex';
import { GameStepsState } from '@/store/modules/gamesteps/state';

export type Mutations<S = GameStepsState> = {
  setCurrentStep(state: S, currentStep: number): void;
  setTotalSteps(state: S, totalSteps: number): void;
};

export const mutations: MutationTree<GameStepsState> & Mutations = {
  setCurrentStep(state: GameStepsState, currentStep: number) {
    state.currentStep = currentStep;
  },
  setTotalSteps(state: GameStepsState, totalSteps: number) {
    state.totalSteps = totalSteps;
  }
};
